import {
  FacilityFlowCoreModulesPlanningEntitiesPlanEntryStatus,
  FacilityFlowCoreModulesPlanningEntitiesPlanEntryConflictFlags,
} from '../api/generated/models';

// --- PlanEntry Status ---
export const PlanEntryStatus = {
  Planned: FacilityFlowCoreModulesPlanningEntitiesPlanEntryStatus.NUMBER_1,
  Conflict: FacilityFlowCoreModulesPlanningEntitiesPlanEntryStatus.NUMBER_2,
  ToPlan: FacilityFlowCoreModulesPlanningEntitiesPlanEntryStatus.NUMBER_3,
  Done: FacilityFlowCoreModulesPlanningEntitiesPlanEntryStatus.NUMBER_4,
} as const;

export type PlanEntryStatusType = (typeof PlanEntryStatus)[keyof typeof PlanEntryStatus];

export const PlanEntryStatusLabel: Record<number, string> = {
  [PlanEntryStatus.Planned]: 'Geplant',
  [PlanEntryStatus.Conflict]: 'Konflikt',
  [PlanEntryStatus.ToPlan]: 'Zu planen',
  [PlanEntryStatus.Done]: 'Erledigt',
};

// --- PlanEntry ConflictFlags (bitfield) ---
export const PlanEntryConflictFlags = {
  None: FacilityFlowCoreModulesPlanningEntitiesPlanEntryConflictFlags.NUMBER_0,
  Holiday: FacilityFlowCoreModulesPlanningEntitiesPlanEntryConflictFlags.NUMBER_1,
  Absence: FacilityFlowCoreModulesPlanningEntitiesPlanEntryConflictFlags.NUMBER_2,
  NotWorkday: FacilityFlowCoreModulesPlanningEntitiesPlanEntryConflictFlags.NUMBER_4,
  Overlap: FacilityFlowCoreModulesPlanningEntitiesPlanEntryConflictFlags.NUMBER_8,
} as const;

export function hasConflictFlag(flags: number | undefined, flag: number): boolean {
  if (flags === undefined) return false;
  return (flags & flag) !== 0;
}

export function getConflictLabels(flags: number | undefined): string[] {
  if (!flags) return [];
  const labels: string[] = [];
  if (hasConflictFlag(flags, PlanEntryConflictFlags.Holiday)) labels.push('Feiertag');
  if (hasConflictFlag(flags, PlanEntryConflictFlags.Absence)) labels.push('Abwesenheit');
  if (hasConflictFlag(flags, PlanEntryConflictFlags.NotWorkday)) labels.push('Kein Arbeitstag');
  if (hasConflictFlag(flags, PlanEntryConflictFlags.Overlap)) labels.push('Überschneidung');
  return labels;
}
